export default __webpack_public_path__ + "static/media/warning-icon.be16b4f7.svg";